import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function MobileNavigation({ menuItems = [], courseTabs = [], t, showCourseLinks = true, onSignOut, onLogin, logo}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCoursesOpen, setMobileCoursesOpen] = useState(false);
  const closeMenu = () => { setMobileOpen(false); setMobileCoursesOpen(false); };

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  const courses = [
    { label: "HTML & CSS", to: "/courses?filter=web&course=html" },
    { label: "PYTHON", to: "/courses?filter=web&course=python" },
    { label: "JAVA SCRIPT", to: "/courses?filter=web&course=javascript" },
    { label: "SEO", to: "/courses?filter=marketing&course=seo" },
    { label: "SOCIAL MEDIA MARKETING", to: "/courses?filter=marketing&course=smm" },
    { label: "TRADING FUNDAMENTALS", to: "/courses?filter=finance&course=fundamentals" }
  ];

  return (
    <>
      <button
        className={`navigation__hamburger ${mobileOpen ? "is-open" : ""}`}
        onClick={() => setMobileOpen(prev => !prev)}
        aria-label="Open navigation"
        aria-expanded={mobileOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>
      <div className={`mobile-overlay ${mobileOpen ? "open" : ""}`}
        onClick={closeMenu}
      />
      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        {logo && (
          <div className="mobile-menu-header">
            <NavLink to="/" onClick={closeMenu}>
              <img src={logo} className="mobile-menu-logo" alt="Vix Academy" />
            </NavLink>
          </div>
        )}
        <div className="mobile-menu-content">
          <div className="mobile-menu-group">
            {menuItems.map((item, i) =>
              item.to ? (
                <NavLink className="mobile-menu-link"
                  key={i} to={item.to} onClick={closeMenu}
                >
                  {item.label}
                </NavLink>
              ) : (
                <button className="mobile-menu-link"
                  key={i}
                  onClick={() => { item.action?.(); closeMenu(); }}
                >
                  {item.label}
                </button>
              )
            )}
          </div>

          {showCourseLinks && (
            <div className="mobile-menu-group">
              <button className={`mobile-menu-link mobile-courses-trigger ${mobileCoursesOpen ? "open" : ""}`}
                onClick={() => setMobileCoursesOpen(prev => !prev)}
              >
                <span>{t("courses")}</span>
                <span className={`mobile-course-arrow ${mobileCoursesOpen ? "open" : ""}`}> + </span>
              </button>
              <div className={`mobile-submenu ${mobileCoursesOpen ? "open" : ""}`}>
                {courses.map(course => (
                  <NavLink key={course.to} to={course.to} onClick={closeMenu}>
                    {course.label}
                  </NavLink>
                ))}
              </div>
            </div>
          )}
          {courseTabs.length > 0 && (
            <>
              <div className="mobile-menu-divider" />
              <div className="mobile-menu-group course-navigation-group">
                {courseTabs.map((item, i) => (
                  <NavLink className="mobile-menu-link mobile-course-tab"
                    key={i} to={item.to} onClick={closeMenu}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </>
          )}

          {(onSignOut || onLogin) && (
            <div className="mobile-menu-bottom">
              {onSignOut && (
                <button className="mobile-menu-link mobile-logout"
                  onClick={() => { onSignOut(); closeMenu(); }}
                >
                  {t("logout")}
                </button>
              )}
              {onLogin && (
                <button className="mobile-menu-link mobile-login"
                  onClick={() => { onLogin(); closeMenu(); }}
                >
                  {t("login")}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MobileNavigation;